import { Paper, Avatar, Box } from '@mui/material';
import { useStatusCountCardLargePlaceholderStyles } from './status-count-card-large-placeholder.styles';
import { useStatusCountCardLargeStyles } from './status-count-card-large.styles';

export function StatusCountCardLargePlaceholder() {
  const sharedClasses = useStatusCountCardLargeStyles();
  const placeholderClasses = useStatusCountCardLargePlaceholderStyles();
  return (
    <Paper className={sharedClasses.card}>
      <Box className={placeholderClasses.title} />
      <div className={sharedClasses.iconWrapper}>
        <Avatar
          className={placeholderClasses.avatar}
          style={{ backgroundColor: 'lightgrey', width: '144px', height: '144px' }}
        >
          {' '}
          {/* Single space char to prevent avatar falling back to default icon */}
        </Avatar>
      </div>
      <Box className={placeholderClasses.subitle} />
      <Box className={placeholderClasses.count} />
    </Paper>
  );
}
